import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Alert from "../../../../../../CommonComponents/Info/Alert/Alert";
import { withContents } from "../../../../../../CommonComponents/ContentMessages";

// This component checks for heading and body fields, if they are returned by drupal api then display
// else do no display
function GrantAlert({ type, heading, history, body, contents = {} }) {
  useEffect(() => {
    let elem = document.getElementById("howItWorksLink");
    if (elem) {
      elem.addEventListener("click", (e) => {
        e.preventDefault();
        history.push("/grants/how-it-works");
      });
    }
  });

  if (!contents[heading] && !contents[body]) {
    return null;
  }
  return (
    <Alert
      type={type}
      heading={<div dangerouslySetInnerHTML={{ __html: contents[heading] }} />}
      body={<div dangerouslySetInnerHTML={{ __html: contents[body] }} />}
      hideButton={!contents[body]}
    />
  );
}

GrantAlert.propTypes = {
  type: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  history: PropTypes.object,
  body: PropTypes.string.isRequired,
  contents: PropTypes.objectOf(PropTypes.string),
};

export default withContents(GrantAlert);
